import { Step } from 'actions/step.action';
import Address from 'containers/address';
import BankAccountConfiguration from 'containers/bankaccount-configuration';
import ConfirmationPage from 'containers/confirmation';
import AboutCompany from 'containers/direto/about-company';
import AlreadyRegisteredMail from 'containers/direto/already-registered-mail';
import AmountRequested from 'containers/direto/amount-requested';
import AwaitingCreditRating from 'containers/direto/awaiting-credit-rating';
import PrivacyTerms from 'containers/direto/privacy-terms';
import ReasonForLoan from 'containers/direto/reason-for-loan';
import ResponsibleInfo from 'containers/direto/responsible-info';
import Welcome from 'containers/direto/welcome';
import ErrorPage from 'containers/error';
import ExpiredProposalPage from 'containers/expired-proposal';
import FeedbackPage from 'containers/feedback';
import LoadProposal from 'containers/load-proposal';
import LoanConfiguration from 'containers/loan-configuration';
import LoanDeniedPage from 'containers/loan-denied';
import SummaryPage from 'containers/summary';
import ThanksFeedbackPage from 'containers/thanks-feedback';
import { NavSection } from 'enums/enums';
import CompanyInfo from 'containers/pre-approved/company-info';
import AntiFraudContainer from 'containers/antifraud/anti-fraud';
import AntiFraudPartnerContainer from 'containers/antifraud/anti-fraud-partner';
import { BlankWrapper, BizonCheckoutWrapper } from 'components/commons/wrapper';
import DocumentContainer from 'containers/documents/document-container';
import Approval from 'containers/antifraud/approval';
import PartnerDocumentForm from 'containers/documents/partner-document-form';
import ShareAntiFraudUrl from 'containers/antifraud/share-antifraud-url';
import LoanInformation from 'containers/loan-information/loan-information';

type RouteProps = {
    path: RoutePath;
    step: Step;
    navSection: NavSection;
    component: React.FC;
    exact?: boolean;
    pathToTrack?: string;
    wrapper?: React.FC;
}

export type RoutePath = '/'
    | '/motivo'
    | '/dados-pessoais'
    | '/sobre-a-empresa'
    | '/termos-de-uso'
    | '/analise'
    | '/:loanApplicationId'
    | '/:loanApplicationId/configuracao'
    | '/:loanApplicationId/informacao'
    | '/:loanApplicationId/endereco'
    | '/:loanApplicationId/dados-bancarios'
    | '/:loanApplicationId/confirmacao'
    | '/:loanApplicationId/resumo'
    | '/:loanApplicationId/feedback'
    | '/:loanApplicationId/error'
    | '/:loanApplicationId/expirado'
    | '/:loanApplicationId/negado'
    | '/:loanApplicationId/cancelado'
    | '/:loanApplicationId/dados-da-empresa'
    | '/:loanApplicationId/identificacao'
    | '/:loanApplicationId/identificacao/socio-nao-identificado'
    | '/:loanApplicationId/identificacao/socio-invalido'
    | '/:loanApplicationId/identificacao/compartilhe-com-socio'
    | '/:loanApplicationId/identificacao/enviado-com-sucesso'
    | '/:loanApplicationId/identificacao/prova-de-vida'
    | '/:loanApplicationId/identificacao/questionario'
    | '/:loanApplicationId/socio/identificacao'
    | '/:loanApplicationId/socio/identificacao/status'
    | '/:loanApplicationId/socio/identificacao/prova-de-vida'
    | '/:loanApplicationId/socio/identificacao/questionario'
    | '/:loanApplicationId/documentacao'
    | '/:loanApplicationId/escolha-conta-bancaria'
    | '/:loanApplicationId/socios/:signerId/documentacao'
    | '/:loanApplicationId/aprovado'
    | '/:loanApplicationId/compartilhe-com-seu-cliente'
    | '/bem-vindo'
    | '/email-cadastrado';

export const defaultApplicationRoutes: RouteProps[] = [
    {
        path: '/',
        exact: true,
        step: Step.DIRETO,
        navSection: NavSection.REQUEST,
        component: AmountRequested,
    },
    {
        path: '/motivo',
        pathToTrack: '/pedido/motivo',
        step: Step.DIRETO,
        navSection: NavSection.REQUEST,
        component: ReasonForLoan,
    },
    {
        path: '/dados-pessoais',
        pathToTrack: '/pedido/dados-pessoais',
        step: Step.DIRETO,
        navSection: NavSection.INFORMATION,
        component: ResponsibleInfo,
    },
    {
        path: '/sobre-a-empresa',
        pathToTrack: '/pedido/sobre-a-empresa',
        step: Step.DIRETO,
        navSection: NavSection.INFORMATION,
        component: AboutCompany,
    },
    {
        path: '/termos-de-uso',
        pathToTrack: '/pedido/termos-de-uso',
        step: Step.DIRETO,
        navSection: NavSection.INFORMATION,
        component: PrivacyTerms,
    },
    {
        path: '/analise',
        pathToTrack: '/pedido/analise',
        step: Step.ANALYSE,
        navSection: NavSection.INFORMATION,
        component: AwaitingCreditRating,
    },
    {
        path: '/:loanApplicationId/configuracao',
        pathToTrack: '/pedido/configuracao',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: LoanConfiguration,
    },
    {
        path: '/:loanApplicationId/informacao',
        pathToTrack: '/pedido/informacao',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: LoanInformation,
    },
    {
        path: '/:loanApplicationId/identificacao',
        pathToTrack: '/pedido/identificacao',
        step: Step.BIZON,
        navSection: NavSection.IDENTITY,
        component: AntiFraudContainer,
        wrapper: BlankWrapper,
    },
    {
        path: '/:loanApplicationId/socio/identificacao',
        pathToTrack: '/pedido/socio/identificacao',
        step: Step.BIZON,
        navSection: NavSection.IDENTITY,
        component: AntiFraudPartnerContainer,
        wrapper: BlankWrapper,
    },
    {
        path: '/:loanApplicationId/documentacao',
        pathToTrack: '/pedido/documentacao',
        step: Step.BIZON,
        navSection: NavSection.IDENTITY,
        component: DocumentContainer,
        wrapper: BlankWrapper,
    },
    {
        path: '/:loanApplicationId/socios/:signerId/documentacao',
        pathToTrack: '/pedido/documentacao-dos-socios',
        step: Step.BIZON,
        navSection: NavSection.IDENTITY,
        component: PartnerDocumentForm,
        wrapper: BlankWrapper,
    },
    {
        path: '/:loanApplicationId/compartilhe-com-seu-cliente',
        pathToTrack: '/pedido/compartilhe-com-seu-cliente',
        step: Step.BIZON,
        navSection: NavSection.IDENTITY,
        component: ShareAntiFraudUrl,
    },
    {
        path: '/:loanApplicationId/aprovado',
        pathToTrack: '/pedido/aprovado',
        step: Step.FLOW_FINISHED,
        navSection: NavSection.IDENTITY,
        component: Approval,
        wrapper: BizonCheckoutWrapper,
    },
    {
        path: '/:loanApplicationId/endereco',
        pathToTrack: '/pedido/endereco',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: Address,
    },
    {
        path: '/:loanApplicationId/dados-bancarios',
        pathToTrack: '/pedido/dados-bancarios',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: BankAccountConfiguration,
    },
    {
        path: '/:loanApplicationId/confirmacao',
        pathToTrack: '/pedido/confirmacao',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: ConfirmationPage,
    },
    {
        path: '/email-cadastrado',
        pathToTrack: '/pedido/email-cadastrado',
        step: Step.BALCAO,
        navSection: NavSection.COMPLETE,
        component: AlreadyRegisteredMail,
    },
    {
        path: '/:loanApplicationId/resumo',
        pathToTrack: '/pedido/resumo',
        step: Step.BALCAO,
        navSection: NavSection.COMPLETE,
        component: SummaryPage,
    },
    {
        path: '/bem-vindo',
        pathToTrack: '/pedido/bem-vindo',
        step: Step.FLOW_FINISHED,
        navSection: NavSection.COMPLETE,
        component: Welcome,
    },
    {
        path: '/:loanApplicationId/feedback',
        pathToTrack: '/pedido/feedback',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: FeedbackPage,
    },
    {
        path: '/:loanApplicationId/error',
        pathToTrack: '/pedido/error',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: ErrorPage,
    },
    {
        path: '/:loanApplicationId/expirado',
        pathToTrack: '/pedido/expirado',
        step: Step.BALCAO,
        navSection: NavSection.COMPLETE,
        component: ExpiredProposalPage,
    },
    {
        path: '/:loanApplicationId/negado',
        pathToTrack: '/pedido/negado',
        step: Step.BALCAO,
        navSection: NavSection.COMPLETE,
        component: LoanDeniedPage,
    },
    {
        path: '/:loanApplicationId/cancelado',
        pathToTrack: '/pedido/cancelado',
        step: Step.BALCAO,
        navSection: NavSection.COMPLETE,
        component: ThanksFeedbackPage,
    },
    {
        path: '/:loanApplicationId',
        pathToTrack: '/pedido/balcao',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: LoadProposal,
    },
];


const preApprovedCustomRoutes: RouteProps[] = [
    {
        path: '/:loanApplicationId/dados-da-empresa',
        pathToTrack: '/pedido/pre-aprovado/dados-da-empresa',
        step: Step.BALCAO,
        navSection: NavSection.CONFIRMATION,
        component: CompanyInfo,
    },
];


const defaultDataFillOutFlow = [
    { path: '/' },
    { path: '/motivo' },
    { path: '/dados-pessoais' },
    { path: '/sobre-a-empresa' },
    { path: '/termos-de-uso' },
    { path: '/analise' },
    { path: '/:loanApplicationId/configuracao' },
    { path: '/:loanApplicationId/endereco' },
    { path: '/:loanApplicationId/dados-bancarios' },
    { path: '/:loanApplicationId/confirmacao' },
    { path: '/email-cadastrado' },
    { path: '/:loanApplicationId/resumo' },
    { path: '/bem-vindo' },
    { path: '/:loanApplicationId/feedback' },
    { path: '/:loanApplicationId/error' },
    { path: '/:loanApplicationId/expirado' },
    { path: '/:loanApplicationId/negado' },
    { path: '/:loanApplicationId/cancelado' },
    { path: '/:loanApplicationId' },
];

const screensFields = [
    { id: "ReasonForLoan", fields: ["reason", "reasonDetail"] },
    { id: "AboutCompany", fields: ["companyDocument", "monthlyRevenue", "relationship"] },
    { id: "AddressConfiguration", fields: ["zipCode", "address"] },
    { id: "BankAccountConfiguration", fields: ["bank", "account"] },
];

export const getFieldOrder = (components: any[], screenName: string) => {
    const newOrder = [];

    screensFields.forEach((cluster) => {
        if (cluster.id === screenName) {
            cluster.fields.forEach((fieldId) => {
                components.forEach((component) => {
                    if (component.id === fieldId) {
                        newOrder.push(component);
                    }
                });

            });
        }
    });
    return newOrder;
}

export const getDefaultDataFillOutFlow = () => defaultDataFillOutFlow;

export const getRouterOrder = () => defaultApplicationRoutes;
export const getPreApprovedCustomRoutes = () => preApprovedCustomRoutes;

export default { defaultApplicationRoutes, getRouterOrder, getPreApprovedCustomRoutes, getFieldOrder, getDefaultDataFillOutFlow };
